import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { faBookOpenCover } from "@fortawesome/pro-solid-svg-icons/faBookOpenCover";
import { faCompassDrafting } from "@fortawesome/pro-solid-svg-icons/faCompassDrafting";
import { faGraduationCap } from "@fortawesome/pro-solid-svg-icons/faGraduationCap";
import { faHandHoldingHand } from "@fortawesome/pro-solid-svg-icons/faHandHoldingHand";
import { faIdBadge } from "@fortawesome/pro-solid-svg-icons/faIdBadge";
import { faIndustryWindows } from "@fortawesome/pro-solid-svg-icons/faIndustryWindows";
import { faMemoCircleCheck } from "@fortawesome/pro-solid-svg-icons/faMemoCircleCheck";
import { faPlaneDeparture } from "@fortawesome/pro-solid-svg-icons/faPlaneDeparture";
import { UserCredentialType } from "generated/CoreApi_v1";

///
export function getCredentialIcon(credentialType: UserCredentialType): IconDefinition {
    let icon;
    switch (credentialType) {
        case UserCredentialType.PositionsHeld:
            icon = faIdBadge;
            break;
        case UserCredentialType.ProfessionalExperience:
            icon = faIndustryWindows;
            break;
        case UserCredentialType.WorkProjects:
            icon = faCompassDrafting;
            break;
        case UserCredentialType.AcademicBackground:
            icon = faGraduationCap;
            break;
        case UserCredentialType.Research:
            icon = faBookOpenCover;
            break;
        case UserCredentialType.PaperOrPublication:
            icon = faMemoCircleCheck;
            break;
        case UserCredentialType.InternationalActivity:
            icon = faPlaneDeparture;
            break;
        case UserCredentialType.VolunteerWork:
            icon = faHandHoldingHand;
            break;
    }

    return icon;
}
